/* angular:styles/component:css;9bf6f305eaf2253a6b87cf36b5551c5b08ecf89bc10876c9b0713a8ea37e7302;C:\fonte\MktplaceView\src\app\app-lost-connection-bar.component.ts */
.connection-bar {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #b3261e;
  color: #fff;
  font:
    500 14px/1.2 system-ui,
    -apple-system,
    sans-serif;
  overflow: hidden;
  transform: translateY(-100%);
  opacity: 0;
  max-height: 0;
  padding: 0 16px;
  transition:
    transform .35s ease,
    max-height .35s ease,
    opacity .25s ease,
    padding .35s ease;
}
.connection-bar.visible {
  transform: translateY(0);
  opacity: 1;
  max-height: 80px;
  padding: 10px 16px;
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  animation: cb-pulse 1s ease-in-out infinite;
}
@keyframes cb-pulse {
  0%, 100% {
    opacity: .4;
  }
  50% {
    opacity: 1;
  }
}
/*# sourceMappingURL=app-lost-connection-bar.component.css.map */
